import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";


export const anchorsScroll = () => {

    gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();
            const blockId = this.getAttribute("href");
            const escapedId = blockId.replace("#", '');
            const target = anchor.classList.contains('chrono-item-btn') ? document.querySelector(`.chrono-content [data-id="${escapedId}"]`) : document.querySelector(this.getAttribute("href"));
            const scroller = anchor.classList.contains('chrono-item-btn') ? '.chrono-content' : '.main';
            if (target) {

                gsap.to(scroller, {
                    duration: 0.5,
                    scrollTo: {
                        y: target,
                    },
                    ease: "power2.out"
                });
            }
        });
    })

    // ScrollTrigger for Extra sections with IDs

    document.querySelectorAll(".extra-section[id]").forEach(section => {
        ScrollTrigger.create({
            scroller: '.main',
            trigger: section,
            start: "top center", // or "top top" if you want exact top
            end: "bottom center",
            onEnter: () => setActive(section.id),
            onEnterBack: () => setActive(section.id),
            onLeave: () => setActive(""),
            onLeaveBack: () => setActive(""),
        });
    });

    // ScrollTrigger Text Sections

    document.querySelectorAll(".bio-section").forEach(section => {
        ScrollTrigger.create({
            scroller: '.main',
            trigger: section,
            start: "top center", // or "top top" if you want exact top
            end: "bottom center",
            onEnter: () => setActive(section.dataset.id),
            onEnterBack: () => setActive(section.dataset.id),
            onLeave: () => setActive(""),
            onLeaveBack: () => setActive(""),
        });
    });

    function setActive(id) {
        console.log("Setting active link for:", id);
        document.querySelectorAll("a[href^='#']").forEach(link => {
            link.classList.toggle("active", link.getAttribute("href") === `#${id}`);
        });
    }
    function removeActive() {
        document.querySelectorAll("a[href^='#']").forEach(link => {
            link.classList.remove("active");
        });
    }
}